import React from "react";
import { useQuery } from "@apollo/client";
import { dateToString } from "../../utils/date-converter";
import { GET_AUTHED_CLIENT_QUERY } from "../../graphql/queries/clients";
import Loader from "../../components/loader/loader";
import Table from "../../components/table/table";
import TableCellRenderer from "../../components/table/table-cell-renderer";

const MyHistory = () => {
  const clientTransationResponse = useQuery(GET_AUTHED_CLIENT_QUERY);

  if (clientTransationResponse.loading) {
    return <Loader sizeClass={"size--medium"} />;
  }

  if (clientTransationResponse.error) {
    return <div className="display-page__error">Something went wrong</div>;
  }
  return (
    <div className="display-page">
      <div className="display-page__title">Recent Transactions</div>
      <div className="display-page__table">
        <Table
          stickyHeader={true}
          data={
            clientTransationResponse.data.authenticatedClient?.transactionSet
          }
          columns={[
            {
              field: "timestamp",
              title: "Timestamp",
              showOnMobile: true,
              hideMobileUp: false,
              render: ({ timestamp }) => {
                return (
                  <TableCellRenderer firstItem={dateToString(timestamp)} />
                );
              },
            },
            {
              field: "type",
              title: "Type",
              showOnMobile: true,
              hideMobileUp: false,
              render: ({ purchaseType }) => {
                return <TableCellRenderer firstItem={purchaseType} />;
              },
            },
            {
              field: "amount",
              title: "Amount",
              showOnMobile: true,
              hideMobileUp: false,
              render: ({ amount }) => {
                return <TableCellRenderer firstItem={amount} />;
              },
            },
            {
              field: "vendor",
              title: "Vendor",
              showOnMobile: true,
              hideMobileUp: false,
              render: ({ vendor }) => {
                return <TableCellRenderer firstItem={vendor} />;
              },
            },
            {
              field: "platform",
              title: "Platform",
              showOnMobile: true,
              hideMobileUp: false,
              render: () => {
                return <TableCellRenderer firstItem={"--"} />;
              },
            },
            {
              field: "success",
              title: "Success",
              showOnMobile: true,
              hideMobileUp: false,
              render: ({ success }) => {
                return (
                  <TableCellRenderer
                    firstItem={success ? "YES" : "NO"}
                    firstItemClass={success === true ? "success" : "danger"}
                  />
                );
              },
            },
            {
              field: "transactionId",
              title: "Transaction ID",
              showOnMobile: true,
              hideMobileUp: false,
              render: ({ id }) => {
                return <TableCellRenderer firstItem={id} />;
              },
            },
          ]}
        />
      </div>
    </div>
  );
};

export default MyHistory;
